import * as React from 'react';
import { FontIcon, ImageIcon } from '@fluentui/react/lib/Icon';
import type { IImageProps } from '@fluentui/react/lib/Image';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react-lite';
import { UpdateExistingOneDrive, AddToOneDriveLabel } from '../../strings.locstring.json';
import loc from 'owa-localize';

import styles from './AttachmentContextMenuIconButton.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface AttachmentContextMenuIconButtonProps {
    iconProps: IImageProps;
    itemText: string;
    shouldShowDiamond: boolean;
    isAlreadySaved: boolean;
}

export default observer(function AttachmentContextMenuIconButton(
    props: AttachmentContextMenuIconButtonProps
) {
    const tooltipContent = props.isAlreadySaved
        ? loc(UpdateExistingOneDrive)
        : loc(AddToOneDriveLabel);
    return (
        <>
            <ImageIcon className={styles.menuIcon} imageProps={props.iconProps} />
            <span className={styles.menuText}>{props.itemText}</span>
            <TooltipHost content={props.shouldShowDiamond ? null : tooltipContent}>
                <FontIcon
                    className={classNames(styles.menuIcon, styles.icon)}
                    iconName={props.shouldShowDiamond ? ControlIcons.Diamond : ControlIcons.Info}
                />
            </TooltipHost>
        </>
    );
});
